<template>
  <section class="sec sec-02 sec-padding" id="about" ref="about">
    <div class="container-fluid">
      <div class="row scene-item1">
        <!-- <div class="sec-title">
          <h1 class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" v-html="title"></h1>
          <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".7s" v-html="titleSub"></p>
        </div> -->
      </div>
      <div class="row justify-content-center podium-container">
        <div class="col-lg-12 mt-5">
          <div class="sec-title ">
            <h1 class="has-u-line wow fadeInUp" data-wow-duration="1s" data-wow-delay=".3s" v-html="probSecTitle"></h1>
            <p class="wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" v-html="probSecSubTitle"></p>
          </div>
        </div>
        <div class="col-lg-12 podium-main">
          <div class="row">
                    <div class="col-lg-3 podium-l-texts">
          <div class="podium-left">
            <h3 >{{problems.l1.t}}</h3>
            <p >{{problems.l1.p}}</p>
          </div>
          <div class="podium-left">
            <h3 >{{problems.l2.t}}</h3>
            <p >{{problems.l2.p}}</p>
          </div>
        </div>
        <div class="col-lg-6 p0">
          <div class="podium">
            <span class="problem"></span>
            <span class="solution"></span>
            <span class="centerbeam">
              <canvas id="particles"></canvas>
            </span>
            <span class="beamloago"></span>
            <span class="legs"></span>
            <img class="hidden base-img1" src="/theme/img/podium-base.jpg"/>
            <img class="hidden base-img2" src="/theme/img/legs-mob.png"/>
          </div>
        </div>
        <div class="col-lg-3 podium-r-texts">
          <div class="podium-right">
            <h3 >{{problems.r1.t}}</h3>
            <p >{{problems.r1.p}} </p>
          </div>
          <div class="podium-right">
            <h3>{{problems.r2.t}}</h3>
            <p >{{problems.r2.p}}</p>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from "scrollmagic";
import helpers from '@/plugins/helpers' 

export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    titleSub:{
      type:String,
      default:''
    }
  },
  data(){
    return{
      probSecTitle:`DO YOU FACE THESE CHALLENGES WHILE TRADING?`,
      probSecSubTitle:`There are several challenges faced by a manual trader emotional
              bias such as greed or fear, high screen time,<br />
              execution of recurring tasks and confusion while choosing a
              strategy, etc.`,
      solSecTitle:`Here's how algos help us overcome these challenges`,
      solSecSubTitle:`An AI-optimized automated trading system offers on effortless alternative to a market that the <br/> 
                      traders otehrwise would not have considered.`,
      problems:{
        l1:{
          t:"Stress due to emotional conflicts",
          p:`We, humans, have an inability to completely remove emotional
              biases, doubtfulness, and psychological errors from all
              decision-making, which may lead to a rather frustrating and bad
              trading day.`
        },
        l2:{
          t:`Exhaustion due to trade execution`,
          p:`From analysis to setting appropriate stop loss and selling or
              buying when the price is favorable, the entire execution demands a
              lot of mental and physical stress, which the trader bears and
              leaves him exhausted by the end of the trade.
            `
        },
        r1:{
           t:` Dilemmas while choosing strategies`,
           p:`Since the strategies are chosen manually, they are limited by
              various attributes like time consumption and calculus power. Also
              the back tested and forward tested data of the strategy is never
              considered in this decision-making.`
        },
        r2:{
          t:`High screen time during trading`,
          p:`Trading demands a lot of screen time, which may lead to issues
              like distractions and lower self-control.`
        }
      },
      solutions:{
         l1:{
            t:`Stress-free trading`,
            p:`With AlphaQ you can practice stress-free trading by making the least human involvement.`
         },
         l2:{
            t:`End-to-End Automation`,
            p:`AlphaQ is completely automated, letting the investors get the best at its ease.`
         },
         r1:{
            t:`AI optimized strategies`,
            p:`AI optimized strategies of AlphaQ are free from all human attributes and limitations, executing the strategies appropriately.`
         },
         r2:{
            t:`Reduced Screen Time`,
            p:`Here, AlphaQ provides less screen time since it is entirely operated by artificial intelligence.`
         }
      }
    }
  },
  mounted() {
    this.onscrollHandler();
    this.particleCenterBeam();
  },
  methods: {
    onscrollHandler() {
      var controller = new ScrollMagic.Controller();
      var scene = new ScrollMagic.Scene({
        triggerElement: ".podium-container",
        offset: window.innerHeight * 0.46,
        duration: helpers.isMobile()?"30%":"50%",
      }).setPin(".podium-container");
      var self= this
      var podiumh1 = document.querySelector('.podium-container h1')
      var podiump = document.querySelector('.podium-container p')
      var problem = document.querySelector('.problem')
      var legs = document.querySelector('.legs')
      var podulml1h3 = document.querySelector('.podium-left:nth-child(1) h3')
      var podulml1p = document.querySelector('.podium-left:nth-child(1) p')
      var podulml2h3 = document.querySelector('.podium-left:nth-child(2) h3')
      var podulml2p = document.querySelector('.podium-left:nth-child(2) p')
      var podulmr1h3 = document.querySelector('.podium-right:nth-child(1) h3')
      var podulmr1p = document.querySelector('.podium-right:nth-child(1) p')
      var podulmr2h3 = document.querySelector('.podium-right:nth-child(2) h3')
      var podulmr2p = document.querySelector('.podium-right:nth-child(2) p')
      var centerbeam = document.querySelector('.centerbeam')
      var beamlogo = document.querySelector('.beamloago')
      var solution = document.querySelector('.solution')

      podiumh1.classList.add('on')
      podiump.classList.add('on')
      problem.classList.add('on')
      legs.classList.add('on')
      podulml1h3.classList.add('on'), podulml1p.classList.add('on')
      podulml2h3.classList.add('on'), podulml2p.classList.add('on')
      podulmr1h3.classList.add('on'), podulmr1p.classList.add('on')
      podulmr2h3.classList.add('on'), podulmr2p.classList.add('on')

      scene.on("enter progress", function (e) {
        if (e.scrollDirection == "FORWARD") {
          if (e.progress >0){
            document.querySelector('.sec-02  .has-u-line').classList.add('sec-active')
          }
         if (e.progress >0.5) { 
            problem.classList.remove('on')
            legs.classList.remove('on')
            podulml1h3.classList.remove('on') , podulml1p.classList.remove('on');
            podulml2h3.classList.remove('on') , podulml2p.classList.remove('on');
            podulmr1h3.classList.remove('on') , podulmr1p.classList.remove('on');
            podulmr2h3.classList.remove('on'), podulmr2p.classList.remove('on');
            
        //  }else if (e.progress >0.5 && e.progress<= 1) {
            centerbeam.classList.add('on')
            beamlogo.classList.add('on')
            podiumh1.innerHTML=self.solSecTitle
            podiump.innerHTML=self.solSecSubTitle

            solution.classList.add('on')
            legs.classList.add('on')

            podulml1h3.innerHTML=self.solutions.l1.t
            podulml2h3.innerHTML=self.solutions.l2.t
            podulmr1h3.innerHTML=self.solutions.r1.t 
            podulmr2h3.innerHTML=self.solutions.r2.t

            podulml1p.innerHTML=self.solutions.l1.p
            podulml2p.innerHTML=self.solutions.l2.p
            podulmr1p.innerHTML=self.solutions.r1.p
            podulmr2p.innerHTML=self.solutions.r2.p

            podulml1h3.classList.add('on'), podulml1p.classList.add('on')
            podulml2h3.classList.add('on'), podulml2p.classList.add('on')
            podulmr1h3.classList.add('on'), podulmr1p.classList.add('on')
            podulmr2h3.classList.add('on'), podulmr2p.classList.add('on')

          }
        }else if (e.scrollDirection == "REVERSE") {
           if (e.progress ==0){
            document.querySelector('.sec-02  .has-u-line').classList.remove('sec-active')
          }
        //  // if(e.progress >0 && e.progress<= 0.1){
        //       console.log('Step 1')
        //   }
        //   else if(e.progress >0.1 && e.progress<= 0.2){
        //     console.log('Step 2')
        //   }else if (e.progress >0.4 && e.progress<= 0.5) { 
        //     console.log('Step 3')

            podiumh1.innerHTML=self.probSecTitle
            podiump.innerHTML=self.probSecSubTitle

            centerbeam.classList.remove('on')
            beamlogo.classList.remove('on')
            problem.classList.add('on')
            legs.classList.add('on')

            podulml1h3.innerHTML=self.problems.l1.t
            podulml2h3.innerHTML=self.problems.l2.t
            podulmr1h3.innerHTML=self.problems.r1.t
            podulmr2h3.innerHTML=self.problems.r2.t

            podulml1p.innerHTML=self.problems.l1.p
            podulml2p.innerHTML=self.problems.l2.p
            podulmr1p.innerHTML=self.problems.r1.p
            podulmr2p.innerHTML=self.problems.r2.p

            podulml1h3.classList.add('on'), podulml1p.classList.add('on')
            podulml2h3.classList.add('on'), podulml2p.classList.add('on')
            podulmr1h3.classList.add('on'), podulmr1p.classList.add('on')
            podulmr2h3.classList.add('on'), podulmr2p.classList.add('on')
         // }else if (e.progress >0.5 && e.progress<= 1) {
              solution.classList.remove('on')
            // legs.classList.remove('on')
            // podulml1h3.classList.remove('on') , podulml1p.classList.remove('on');
            // podulml2h3.classList.remove('on') , podulml2p.classList.remove('on');
            // podulmr1h3.classList.remove('on') , podulmr1p.classList.remove('on');
            // podulmr2h3.classList.remove('on'), podulmr2p.classList.remove('on');
         // }
        }
       
      });

      controller.addScene([scene]);
    },
    particleCenterBeam(){
      window.requestAnimFrame = (function() {
        return  window.requestAnimationFrame ||window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame||
        function(callback) { window.setTimeout(callback, 1000 / 60);};
    })();
  
  function createSnow() {
    var particles = [] ,particleSize = 5, maxParticles = 1000 ,particleOpacity = .9;
    var canvas  = document.querySelector('#particles');
    var ctx     = canvas.getContext('2d');
    var windowWidth = window.innerWidth ,windowHeight = window.innerHeight;

    canvas.width = windowWidth;
    canvas.height = windowHeight;

    // Push particle iteration
    for (var i = 0; i < maxParticles; i++) {
      particles.push({ x: Math.random() * windowWidth, y: Math.random() * windowHeight, r: Math.random(Math.min(particleSize)) * particleSize, d: Math.random() * maxParticles});
    }
    function render() {
      ctx.clearRect(0, 0, windowWidth, windowHeight);
      ctx.fillStyle = '#37A2CC';
      ctx.beginPath();
      for(var i = 0; i < maxParticles; i++) {
        var p = particles[i];
        ctx.moveTo(p.x, p.y);
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2, true);
      }
      ctx.fill();
      update();
    }
    var angle = 0.005;
    function update() {
      angle += 0.005;
      for (var i = 0; i < maxParticles; i++) {
        var p = particles[i];
        p.y += Math.cos(p.d) + p.r;
        p.x += Math.sin(angle) * Math.PI / 10;
        if (p.y > windowHeight) {
          particles[i] = { x: Math.random() * windowWidth, y: 0,r: p.r, d: p.d}; 
        }    
      }  
    }
    // Call function.
    (function runtime() {  requestAnimFrame(runtime); render()})();} createSnow();}
  },
};
</script>